import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDate, formatPrice } from '~/common';
import Typography from '@material-ui/core/Typography';

const Component = (props) => {
    const getClassName = (price) => {
        let className = 'context-menu';
        if (props.selectedPrice && props.selectedPrice.id === price.id) {
            className += ' selected';
        }
        return className;
    };

    const getDate = (date) => (date) ? formatDate(new Date(date)) : null;

    // noinspection JSUnresolvedVariable
    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead><TableRow>
                    <TableCell className="offer">Оффер</TableCell>
                    <TableCell className="type">Тип заявки</TableCell>
                    <TableCell className="status">Статус</TableCell>
                    <TableCell className="date_from">Начальная дата</TableCell>
                    <TableCell className="date_to">Конечная дата</TableCell>
                    <TableCell className="price">Цена</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {props.prices.map((price) => (
                        <TableRow key={price.id} className={getClassName(price)}
                                  onContextMenu={props.onContextMenu(price)}
                        >
                            <TableCell className="offer">
                                <Link to={`/offers/${price.offer.offer_name}/`}>{price.offer.offer_name}</Link>
                            </TableCell>
                            <TableCell className="type">{(price.type) ? price.type.name : null}</TableCell>
                            <TableCell className="status">{price.status.status}</TableCell>
                            <TableCell className="date_from">{getDate(price.date_from)}</TableCell>
                            <TableCell className="date_to">{getDate(price.date_to)}</TableCell>
                            <TableCell className="price">
                                <Typography align="right">{formatPrice(price.price)}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    prices: PropTypes.array.isRequired,
    selectedPrice: PropTypes.object,
    onContextMenu: PropTypes.func,
};

export default Component;
